import { StageDefinition } from './StageDefinition';

export const stage12: StageDefinition = {
    platforms: [
        [243.87096774193557, 0],
        [246.31578947368405, 1],
        [245.45454545454555, 2],
        [50.400000000000006, 3],
        [57.60000000000001, 3],
        [64.80000000000001, 3],
        [151.2, 3],
        [158.39999999999998, 3],
        [165.59999999999997, 3],
        [172.79999999999995, 3],
        [179.99999999999994, 3],
        [187.19999999999993, 3],
        [237.59999999999985, 3],
        [244.79999999999984, 3],
        [251.99999999999983, 3],
        [56.842105263157904, 4],
        [63.15789473684212, 4],
        [69.47368421052633, 4],
        [75.78947368421053, 4],
        [82.10526315789474, 4],
        [88.42105263157895, 4],
        [94.73684210526315, 4],
        [4.090909090909091, 9],
        [8.181818181818182, 9],
        [12.272727272727273, 9],
        [16.363636363636363, 9],
        [20.454545454545453, 9],
        [24.545454545454543, 9],
        [28.636363636363633, 9],
        [32.72727272727273, 9],
        [36.81818181818182, 9],
        [40.909090909090914, 9],
        [45.00000000000001, 9],
        [49.0909090909091, 9],
        [53.181818181818194, 9],
        [57.27272727272729, 9],
        [61.36363636363638, 9],
        [65.45454545454547, 9],
        [69.54545454545456, 9],
        [73.63636363636365, 9],
        [77.72727272727275, 9],
        [81.81818181818184, 9],
        [85.90909090909093, 9],
        [90.00000000000003, 9],
        [94.09090909090912, 9],
        [98.18181818181822, 9],
        [102.27272727272731, 9],
        [106.3636363636364, 9],
        [110.4545454545455, 9],
        [114.54545454545459, 9],
        [118.63636363636368, 9],
        [122.72727272727278, 9],
        [126.81818181818187, 9],
        [130.90909090909096, 9],
        [135.00000000000006, 9],
        [139.09090909090915, 9],
        [143.18181818181824, 9],
        [147.27272727272734, 9],
        [151.36363636363643, 9],
        [155.45454545454552, 9],
        [159.54545454545462, 9],
        [163.6363636363637, 9],
        [167.7272727272728, 9],
        [171.8181818181819, 9],
        [175.909090909091, 9],
        [180.00000000000009, 9],
        [184.09090909090918, 9],
        [188.18181818181827, 9],
        [192.27272727272737, 9],
        [196.36363636363646, 9],
        [200.45454545454555, 9],
        [204.54545454545465, 9],
        [208.63636363636374, 9],
        [212.72727272727283, 9],
        [216.81818181818193, 9],
        [220.90909090909102, 9],
        [225.0000000000001, 9],
        [229.0909090909092, 9],
        [233.1818181818183, 9],
        [237.2727272727274, 9],
        [241.3636363636365, 9],
        [245.45454545454558, 9],
        [249.54545454545467, 9],
        [253.63636363636377, 9],
        [257.72727272727286, 9],
        [261.8181818181819, 9],
        [265.909090909091, 9],
        [270.00000000000006, 9],
        [274.0909090909091, 9],
        [278.1818181818182, 9],
        [282.27272727272725, 9],
        [286.3636363636363, 9],
        [290.4545454545454, 9],
        [294.54545454545445, 9],
        [298.6363636363635, 9],
        [302.7272727272726, 9],
        [306.81818181818164, 9],
        [310.9090909090907, 9],
        [314.9999999999998, 9],
        [319.09090909090884, 9],
        [323.1818181818179, 9],
        [327.27272727272697, 9],
        [331.36363636363603, 9],
        [335.4545454545451, 9],
        [339.54545454545416, 9],
        [343.6363636363632, 9],
        [347.7272727272723, 9],
        [351.81818181818136, 9],
        [355.9090909090904, 9],
        [359.9999999999995, 9],
    ],
    traps: [
        [230.39999999999986, 3],
        [259.1999999999998, 3],
        [97.14285714285711, 5],
        [99.13043478260872, 6],
        [100.79999999999997, 7],
    ],
    stars: [
        [87, 6],
        [71, 6],
        [238, 1],
        [256, 1],
        [302, 2],
        [87, 1],
        [24, 2],
        [170, 1],
        [179, 5],
        [162, 5],
        [244, 5],
    ],
};
